import { useFlags } from 'launchdarkly-react-client-sdk'

export function useNoteAmendmentsEnabled(): boolean {
  const { appointmentNoteAmendments } = useFlags()
  return Boolean(appointmentNoteAmendments)
}
